// extracted by mini-css-extract-plugin
module.exports = {"container":"ElementListAdd_container__18-JG","header":"ElementListAdd_header__pkzQV"};